module.exports = __webpack_public_path__ + "static/media/ZBTC.7c8f5e8b.svg";